module.exports = __webpack_public_path__ + "static/img/app_bg3.13d2531.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/app_bg3.jpg
// module id = zVWQ
// module chunks = 0